import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface LegalAgreementsReturn {
  mode: ComputedRef<InputMode>
  label: string
  setAcceptEmailDelivery: () => void
}

export const useAcceptEmailDelivery = (): LegalAgreementsReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'Please make sure our emails are delivered to your inbox and not your spam folder. Check your spam email folder, and if it\'s in your spam folder, remember to mark the email as not spam.'

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && !tutorApplicationStore.acceptEmailDelivery))

  const setAcceptEmailDelivery = (): void => {
    tutorApplicationStore.setAcceptEmailDelivery(!tutorApplicationStore.acceptEmailDelivery)
  }

  return {
    mode,
    label,
    setAcceptEmailDelivery,
  }
}
